import * as React from 'react';
import { Routes, Route, useParams } from 'react-router-dom';
import Layout from './components/Layout';
import ApplicationStartup from './ApplicationStartup';
import { RouteContext as RouteContextModel } from './models';
import PageTypeLoader from 'components/PageTypeLoader';

export const RouteContext = React.createContext({} as RouteContextModel)

const RouteContextWrapper = () => {
    const { pageType, id } = useParams<{ pageType: string; id: string }>();
    return (
        <RouteContext.Provider value={{ id, pageType } as RouteContextModel}>
            <Layout>
                <PageTypeLoader />
            </Layout>
        </RouteContext.Provider>
    );
};

const App = () => (
    <ApplicationStartup>
        <Routes>
            <Route path='/' element={
                <RouteContext.Provider value={{ pageType: 'home' } as RouteContextModel}>
                    <Layout>
                        <PageTypeLoader />
                    </Layout>
                </RouteContext.Provider>
            } />
            <Route path='/:pageType/:id' element={<RouteContextWrapper />} />
        </Routes>
    </ApplicationStartup>
);

export default App;